export type BrandGenericStatusOption = { label: string, value: string };

export const brandGenericStatusOptions: BrandGenericStatusOption[] = [
  { label: 'Brand', value: 'Brand' },
  { label: 'Generic', value: 'Generic' }
];
